// tslint:disable:max-classes-per-file
import { Action } from '@ngrx/store';
export const LOAD_INITIAL_FILTERS = '[Portal] Load Initial Filters';
export const LOAD_INITIAL_PARAMS = '[Portal] Load Initial Params';
export const LOAD_TILE_DATA = '[Portal] Load Tile Data';

export class LoadInitialFilters implements Action {
  readonly type = LOAD_INITIAL_FILTERS;
  constructor(public payload: any) {}
}

export class LoadInitialParams implements Action {
  readonly type = LOAD_INITIAL_PARAMS;
  constructor(public payload: any) {}
}

export class LoadTileData implements Action {
  readonly type = LOAD_TILE_DATA;
  constructor(public payload: any) {}
}

// action types
export type NetworkDashboardAction = LoadInitialFilters | LoadTileData | LoadInitialParams;
